import React from 'react'
import {Icon} from './icon'

export const Short = ({location}) => {
  if (!location) return null

  return <div className="tile tile-centered">
    <div className="tile-icon">
      <Icon name={location.icon} />
    </div>
    <div className="tile-content">
      <div className="tile-title">{location.name}</div>
      <small className="tile-subtitle text-gray">{location.icon}</small>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/short.js